import { Text, View, Image, Font } from '@react-pdf/renderer';
import React from 'react';
import { PUBLICATION_SIGNATURE_AUTHORITY, PUBLICATION_SIGNATURE_TEMPLATE } from '../../../constants';
import logo from "../../../assests/images/Signature.png";
import font from "../../../assests/fonts/ARLRDBD.ttf";

Font.register({
    family: "ARLRDBD",
    format: "truetype",
    src: font
});

const Signature = (props) => {
    const { hideSignature } = props;

    return (
        <>
            <View style={{ flexDirection: "row", paddingTop: 5, alignSelf: "flex-end" }}>
                <View style={{
                    flexDirection: "row", flexGrow: 1,
                    marginRight: 50
                }} >
                    <Text style={{
                        fontSize: 10,
                        display: "flex",
                        alignSelf: "flex-end",
                       
                    }}>{PUBLICATION_SIGNATURE_TEMPLATE}</Text>
                </View>
            </View>
            {!hideSignature && <View style={{ flexDirection: "row", marginRight: 50, alignSelf: "flex-end" }}>
                <Image
                    src={logo}
                    style={{
                        marginTop: 2,
                        width: 100,
                        height: 35
                    }}
                />
            </View>}
            <View style={{ flexDirection: "row", paddingTop: !hideSignature ? 1 : 30, alignSelf: "flex-end" }}>
                <View style={{
                    flexDirection: "row", flexGrow: 1,
                    marginRight: 53
                }} >
                    <Text style={{
                        fontSize: 10,
                        display: "flex",
                        alignSelf: "flex-end",
                      
                    }}>{PUBLICATION_SIGNATURE_AUTHORITY}</Text>
                </View>
            </View>
        </>
    );
}

export default Signature;